import { Component } from '@angular/core';
import { membersuiteBusinessUnitEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Business Units') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitebusinessunit-form',
    templateUrl: './membersuitebusinessunit.form.component.html'
})
export class membersuiteBusinessUnitFormComponent extends BaseFormComponent {
    public record!: membersuiteBusinessUnitEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

